import React, { FunctionComponent } from "react";
import { Router, Switch } from "react-router-dom";

import AdGroupSelectionSlide from "../views/CampaignCreationBasicSlides/AdGroupSelectionSlide";
import AdvertiserDetailPage from "../pages/AdvertiserDetailPage";
import AdvertisersListPage from "../pages/AdvertisersListPage";
import AllBillingLogsPage from "../pages/AllBillingLogsPage";
import AuthGuardRoute from "./AuthGuardRoute";
import AuthManagementRoute from "./AuthManagementRoute";
import CRMRetargetinSegmentsPage from "../pages/CRMRetargetingSegmentsPage";
import CampaignFromTemplateCreatePage from "../pages/CampaignFromTemplateCreatePage";
import CampaignTemplateCreatePage from "../pages/CampaignTemplateCreatePage";
import CampaignTemplatesPage from "../pages/CampaignTemplatesPage";
import CustomCampainCreatePage from "../pages/CustomCampainCreatePage";
import DashboardPage from "../pages/DashboardPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import InvoicesPage from "../pages/InvoicesPage";
import ManagedCampaignCreatePage from "../pages/ManagedCampaignCreatePage";
import PrivacyPage from "../pages/LegalDocsPage/PrivacyPage";
import PublicCampaignPicker from "../containers/PublicCampaignPicker";
import PublicRoute from "./PublicRoute";
import PublicationListSelectionSlide from "../views/CampaignCreationCustomSlides/PublicationListSelectionSlide";
import RoleTitleSelectionSlide from "../views/CampaignCreationBasicSlides/RoleTitleSelectionSlide";
import SegmentsLogsPage from "../pages/SegmentsLogsPage";
import SelectHubspotTargetCompaniesSlide from "../views/CampaignCreationBasicSlides/SelectHubspotTargetCompaniesSlide";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import TermsOfUse from "../pages/LegalDocsPage/TermsOfUse";
import VisitorsRetargetinSegmentsPage from "../pages/VisitorsRetargetingSegmentsPage";
import ZipCodeSelectionSlide from "../views/CampaignCreationCustomSlides/ZipCodeSelectionSlide";
import { ROUTE_PATHS } from "../types/RoutePaths";
import { history } from "../sentry";

const Routes: FunctionComponent = () => {
  return (
    <Router history={history}>
      <Switch>
        <AuthManagementRoute path={`${ROUTE_PATHS.ROOT}`} exact component={SignInPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.SIGNUP}`} exact component={SignUpPage} />
        <AuthManagementRoute path={`${ROUTE_PATHS.FORGOT_PASSWORD}`} exact component={ForgotPasswordPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.DASHBOARD}`} exact component={DashboardPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.ADVERTISERS_LIST}`} exact component={AdvertisersListPage} />
        <AuthGuardRoute path={ROUTE_PATHS.ADVERTISER_DETAIL} exact component={AdvertiserDetailPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.ALLBILLINGLOGS}`} exact component={AllBillingLogsPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.INVOICES}`} exact component={InvoicesPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.MANAGED_CAMPAIGN_CREATE}`} exact component={ManagedCampaignCreatePage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.CUSTOM_CAMPAIGN_CREATE}`} exact component={CustomCampainCreatePage} />
        <AuthGuardRoute
          path={`${ROUTE_PATHS.VISITORS_RE_TARGETING_SEGMENTS}`}
          exact
          component={VisitorsRetargetinSegmentsPage}
        />
        <AuthGuardRoute path={`${ROUTE_PATHS.CRM_RE_TARGETING_SEGMENTS}`} exact component={CRMRetargetinSegmentsPage} />
        <PublicRoute path={`${ROUTE_PATHS.PUBLIC_CAMPAIGNS_PICKER}`} exact component={PublicCampaignPicker} />
        <PublicRoute path={`${ROUTE_PATHS.TERMS_PAGE}`} exact component={TermsOfUse} />
        <PublicRoute path={`${ROUTE_PATHS.PRIVACY_PAGE}`} exact component={PrivacyPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.PUBLICATION_LISTS}`} exact component={PublicationListSelectionSlide} />
        <AuthGuardRoute path={`${ROUTE_PATHS.ADS_UPLOAD}`} exact component={AdGroupSelectionSlide} />
        <AuthGuardRoute path={`${ROUTE_PATHS.TARGET_COMPANIES}`} exact component={SelectHubspotTargetCompaniesSlide} />
        <AuthGuardRoute path={`${ROUTE_PATHS.ROLES_AND_TITLES}`} exact component={RoleTitleSelectionSlide} />
        <AuthGuardRoute path={`${ROUTE_PATHS.SEGMENTS_LOGS}`} exact component={SegmentsLogsPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.ZIP_CODES}`} exact component={ZipCodeSelectionSlide} />
        <AuthGuardRoute
          path={`${ROUTE_PATHS.CAMPAIGN_CREATE_FROM_TEMPLATE}`}
          exact
          component={CampaignFromTemplateCreatePage}
        />
        <AuthGuardRoute path={`${ROUTE_PATHS.CAMPAIGN_TEMPLATES}`} exact component={CampaignTemplatesPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.CREATE_CAMPAIGN_TEMPLATE}`} exact component={CampaignTemplateCreatePage} />
      </Switch>
    </Router>
  );
};

export default Routes;
